import { SalePageType } from '@/api/types';
import { Tag } from '@/components';
import { isNil } from 'lodash-es';

interface SalePageTypeTagProps {
  type?: SalePageType;
}

const label: Record<SalePageType, string> = {
  DIGITAL: '디지털',
  PHYSICAL: '실물',
  GACHA: '가챠',
  FUNDING: '펀딩',
  CLASS: '클래스',
};

export const SalePageTypeTag = ({ type }: SalePageTypeTagProps) => {
  if (isNil(type)) return null;
  return <Tag variant="black" size="small" label={label[type]} />;
};
